export const SETTINGS_PAGE = 'SETTINGS_PAGE'
export const SETTINGS_BILLING_PAGE = 'SETTINGS_BILLING_PAGE'
export const SETTINGS_BILLING_INVOICES_PAGE = 'SETTINGS_BILLING_INVOICES_PAGE'
export const SETTINGS_BILLING_INFORMATION_PAGE =
  'SETTINGS_BILLING_INFORMATION_PAGE'
export const SETTINGS_BILLING_ACTIVITY_PAGE = 'SETTINGS_BILLING_ACTIVITY_PAGE'
export const SETTINGS_COMPANY_BUSINESS_HOURS_PAGE =
  'SETTINGS_COMPANY_BUSINESS_HOURS_PAGE'
export const SETTINGS_CRM_PAGE = 'SETTINGS_CRM_PAGE'
export const SETTINGS_INTEGRATIONS_PAGE = 'SETTINGS_INTEGRATIONS_PAGE'
export const SETTINGS_INTEGRATIONS_PROVIDER_PAGE =
  'SETTINGS_INTEGRATIONS_PROVIDER_PAGE'
export const SETTINGS_INTEGRATIONS_ADD_NEW_PAGE =
  'SETTINGS_INTEGRATIONS_ADD_NEW_PAGE'
export const SETTINGS_INTEGRATIONS_EDIT_PAGE = 'SETTINGS_INTEGRATIONS_EDIT_PAGE'
export const SETTINGS_REPORTS_PAGE = 'SETTINGS_REPORTS_PAGE'
export const SETTINGS_WIDGETS_PAGE = 'SETTINGS_WIDGETS_PAGE'
export const SETTINGS_WIDGETS_CREATE_PAGE = 'SETTINGS_WIDGETS_CREATE_PAGE'
export const SETTINGS_WIDGET_PAGE = 'SETTINGS_WIDGET_PAGE'
export const SETTINGS_WIDGET_CUSTOMIZE_PAGE = 'SETTINGS_WIDGET_CUSTOMIZE_PAGE'
export const SETTINGS_WIDGET_CONTACT_PAGE = 'SETTINGS_WIDGET_CONTACT_PAGE'
export const SETTINGS_WIDGET_KB_PAGE = 'SETTINGS_WIDGET_KB_PAGE'
export const SETTINGS_WIDGET_CHAT_PAGE = 'SETTINGS_WIDGET_CHAT_PAGE'
export const SETTINGS_WIDGET_CHAT_CONVERSATION_PAGE =
  'SETTINGS_WIDGET_CHAT_CONVERSATION_PAGE'
export const SETTINGS_WIDGET_CHAT_ROUTING_PAGE =
  'SETTINGS_WIDGET_CHAT_ROUTING_PAGE'
export const SETTINGS_WIDGET_CHAT_ACL_PAGE = 'SETTINGS_WIDGET_CHAT_ACL_PAGE'
export const SETTINGS_WIDGET_CHAT_BOT_OVERVIEW_PAGE =
  'SETTINGS_WIDGET_CHAT_BOT_OVERVIEW_PAGE'
export const SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE =
  'SETTINGS_WIDGET_CHAT_WELCOME_SKILL_PAGE'
export const SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE =
  'SETTINGS_WIDGET_CHAT_IDENTITY_SKILL_PAGE'
export const SETTINGS_WIDGET_TRANSLATE_PAGE = 'SETTINGS_WIDGET_TRANSLATE_PAGE'
export const SETTINGS_WIDGET_INSTALL_PAGE = 'SETTINGS_WIDGET_INSTALL_PAGE'
export const SETTINGS_WIDGET_FIRST_INSTALL_PAGE =
  'SETTINGS_WIDGET_FIRST_INSTALL_PAGE'

export const SETTINGS_WIDGET_CREATE_NEW_PAGE = 'SETTINGS_WIDGET_CREATE_NEW_PAGE'
export const SETTINGS_WIDGET_CREATE_CUSTOMIZE_PAGE =
  'SETTINGS_WIDGET_CREATE_CUSTOMIZE_PAGE'
export const SETTINGS_WIDGET_CREATE_INSTALL_PAGE =
  'SETTINGS_WIDGET_CREATE_INSTALL_PAGE'
